import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=eeb76c78&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "./box.scss?vue&type=style&index=0&id=eeb76c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb76c78",
  null
  
)

export default component.exports